import { MailControllerApi } from "../client";
import { Api, ApiClient } from "./ApiClient";

export default class MailControllerRepository {
  static getApiClient() {
    return ApiClient.getClient(Api.EmailApi) as MailControllerApi;
  }

  static async sendContestmail(
    fullName: string,
    email: string,
    shinGuardPreview: Blob,
    zipFile: Blob
  ): Promise<boolean> {
    const api = this.getApiClient();
    try {
      return await api.sendContestmail(
        email,
        fullName,
        shinGuardPreview,
        zipFile
      );
    } catch (error) {
      throw Error(error as string);
    }
  }
}
